<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdpessoa) }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">CPF</label>
                    <div class="field-label field-label-center">{{ objEdicao.cpf }}</div>
                </div>
                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <input type="text" v-model="objEdicao.nmpessoa" required maxlength="100" v-uppercase />
                </div>
                <div class="form-item-char30">
                    <label class="label-caption">Apelido</label>
                    <input type="text" v-model="objEdicao.apelido" maxlength="50" v-uppercase />
                </div>
                <div class="form-item-char10">
                    <label class="label-caption">Sigla</label>
                    <input type="text" v-model="objEdicao.sigla" maxlength="10" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Endereço</label>
                    <input type="text" v-model="objEdicao.endereco" maxlength="100" v-uppercase />
                </div>
                <div class="form-item-char10">
                    <label class="label-caption">Número</label>
                    <input type="text" class="input-right" v-model="edNmEndereco" v-number maxlength="5" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Complemento</label>
                    <input type="text" v-model="objEdicao.complemento" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Bairro</label>
                    <input type="text" v-model="objEdicao.bairro" maxlength="100" v-uppercase />
                </div>

                <div class="form-item">
                    <label class="label-caption">Município</label>
                    <input type="text" v-model="objEdicao.nmmunicipio" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-char05">
                    <label class="label-caption">UF</label>
                    <input type="text" v-model="objEdicao.uf" maxlength="2" v-uppercase />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">CEP</label>
                    <input type="text" v-model="objEdicao.cep" v-cep maxlength="10" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-char20">
                    <label class="label-caption">Inscrição</label>
                    <input type="text" class="input-right" v-model="edIe" v-number maxlength="10" />
                </div>
                <div class="form-item-telefone">
                    <label class="label-caption">Telefone</label>
                    <input type="text" v-model="objEdicao.celular" v-phone maxlength="15" />
                </div>
                <div class="form-item-data">
                    <label class="label-caption">Dt Nascimento</label>
                    <input type="date" v-model="objEdicao.dtnascimento"  />
                </div>
                <div class="form-item flexible">
                    <label class="label-caption">Email</label>
                    <input type="email" v-model="objEdicao.email" maxlength="100" />
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Facebook</label>
                    <input type="text" v-model="objEdicao.facebook" maxlength="50" />
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Instagram</label>
                    <input type="text" v-model="objEdicao.instagram" maxlength="50" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Empresa</label>
                    <input type="text" v-model="objEdicao.empresa_nome" maxlength="100" v-uppercase />
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">CNPJ</label>
                    <input type="text" class="input-center" v-model="objEdicao.empresa_cnpj" v-cnpj maxlength="18"/>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Inscrição</label>
                    <input type="text" class="input-right" v-model="edEmpresaIe" v-number maxlength="10" />
                </div>
            </div>
            

            <div class="row row-space">
                <GabineteTpPessoaSelect class="form-item" v-model:tpPessoaSelecionada="objEdicao.idtppessoa" />
                <LocalidadeSelect class="form-item" v-model:idSelecionado="objEdicao.idlocalidade" />
            </div>
            

            <div class="row-end">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarGabinetePessoa } from '@/models/GabinetePessoa';
import { Funcoes } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import GabineteTpPessoaSelect from '@/selects/GabineteTpPessoaSelect.vue';
import LocalidadeSelect from '@/selects/LocalidadeSelect.vue';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({
        idEdicao: {type: Number, default: 0},
        cpfNovo: {type: String, default: ''}});

const edIe = ref(null);
const edEmpresaIe = ref(null);
const edNmEndereco = ref(null);
const objEdicao = ref(criarGabinetePessoa());
const isLoading = ref(false);

const submitForm = async () => {
    try {
        isLoading.value=true;
        objEdicao.value.nmendereco = Funcoes.integerFromString(edNmEndereco.value);
        objEdicao.value.ie = Funcoes.integerFromString(edIe.value);
        objEdicao.value.empresa_ie = Funcoes.integerFromString(edEmpresaIe.value);
        const response = await genericPut('/cad/gabinete_pessoa', objEdicao.value);
        if (response.bolok===1){
            emit('salvo');
            emit('close');
        }else{
            console.error('Error:', response.erro)
        }
    } catch (error) {console.error('Error:', error);
    } finally {isLoading.value=false;}
};

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;

        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('gabinete_pessoa', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.value.idmunicipio = globalStore.idmunicipio;
            objEdicao.value.idlogin = globalStore.idlogin;
            objEdicao.value.cpf = props.cpfNovo;
        }
        objEdicao.value.idusuario   = globalStore.idusuario;
        edNmEndereco.value          = Funcoes.formatInteger(objEdicao.value.nmendereco);
        edIe.value                  = Funcoes.formatInteger(objEdicao.value.ie);
        edEmpresaIe.value           = Funcoes.formatInteger(objEdicao.value.empresa_ie);
    }finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>